import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

const Textslider = {
    breakpoints: {
        0: { slidesPerView: 1 },
        600: { slidesPerView: 1 },
        1000: { slidesPerView: 4 }
      }
};

const textItems = [
    'Multiple campaigns',
    'User friendly',
    'Advanced analytics',
    'Task management',
    'Event Scheduler',
    'Group Video Calls',
    'Live Chat',
    'Activity Streem',
];

function Textlist() {
    return (
        <>
            <div className="text_list_section row_am" data-aos="fade-in" data-aos-duration={1500} >
                <div className="container">
                    <span className="title_badge down_fix">Why choose our app</span>
                </div>
                <div className="slider_block">
                    <Swiper className="mySwiper" id="text_list_flow" {...Textslider} slidesPerView={2.1}>
                        {textItems.map((item, index) => (
                            <SwiperSlide key={index} className="item">
                                <div className="text_block">
                                    <span>{item}</span>
                                    <span className="mark_star">•</span>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
}

export default Textlist;
